The hiring organization for the given `id`.

This query accepts browser tokens that include the `query:organizations` or `query:enhanced-job-posting` scope.
